var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.062,3.988H5.938A1.932,1.932,0,0,0,4.005,5.921V18.079a1.932,1.932,0,0,0,1.933,1.933H18.062A1.932,1.932,0,0,0,20,18.079V5.921A1.932,1.932,0,0,0,18.062,3.988ZM5.938,5.313H18.062a.608.608,0,0,1,.608.608v7.972L16.279,11.4a.661.661,0,0,0-.471-.2.845.845,0,0,0-.474.192l-2.512,2.494-3.561-3.56a.662.662,0,0,0-.469-.2h0a.659.659,0,0,0-.468.2L5.33,13.344V5.921A.608.608,0,0,1,5.938,5.313ZM18.062,18.687H5.938a.608.608,0,0,1-.608-.608V15.214c.01-.009.024-.012.033-.022l3.431-3.458,3.558,3.557a.661.661,0,0,0,.935,0l2.5-2.485,2.84,2.955c.012.013.028.017.041.028v2.288A.608.608,0,0,1,18.062,18.687Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,10.439A1.644,1.644,0,1,0,11.158,8.8,1.646,1.646,0,0,0,12.8,10.439Zm0-2.4a.76.76,0,1,1-.761.76A.761.761,0,0,1,12.8,8.035Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.71366f68189093a347f32c62a9a6d755.svg";
export { ForwardRef as ReactComponent };